import values from 'lodash/values'
import { createSelector } from 'reselect'

const _filters = state => state.mySearches.filters
const _page = state => state.mySearches.page
const _searches = state => state.mySearches.searches.data

export const form = state => state.mySearches.form
export const layout = state => state.mySearches.layout
export const limit = state => state.mySearches.limit
export const searches = state => state.mySearches.searches
export const sortBy = state => state.mySearches.sortBy
export const sortOrder = state => state.mySearches.sortOrder
export const user = state => state.auth.user

/**
 * Iterates over all rugs and filters out all rugs which don't meet at least
 * one of the filter criteria.
 */
export const filterSearches = createSelector(
  [_searches, _filters],
  (searches, filters) => {
    const { name } = filters

    return values(searches).filter(search => {
      if (!search.name.toLowerCase().includes(name.toLowerCase())) {
        return false
      }

      return true
    })
  },
)

/**
 * Takes the searches and sorts them.
 */
export const sortSearches = createSelector(
  [filterSearches, sortBy, sortOrder],
  (searches, sortBy, sortOrder) => {
    return searches.slice().sort((a, b) => {
      switch (sortBy) {
        case 'name': {
          if (sortOrder === 'ascending') {
            return a.name
              .trim()
              .toLowerCase()
              .localeCompare(b.name.trim().toLowerCase())
          } else {
            return b.name
              .trim()
              .toLowerCase()
              .localeCompare(a.name.trim().toLowerCase())
          }
        }

        case 'rugs': {
          if (sortOrder === 'ascending') {
            return a.rugs - b.rugs
          } else {
            return b.rugs - a.rugs
          }
        }

        case 'dateCreated': {
          if (sortOrder === 'ascending') {
            return new Date(a.createdAt) - new Date(b.createdAt)
          } else {
            return new Date(b.createdAt) - new Date(a.createdAt)
          }
        }

        default:
          return a.name.localeCompare(b.name)
      }
    })
  },
)

/**
 * Takes the sorted searches and slices the array to the set limit per page.
 */
export const slicedSortedSearches = createSelector(
  [sortSearches, limit, _page],
  (sortedSearches, limit, page) => {
    return sortedSearches.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

/**
 * Creates a pagination object with current page, total pages, total searches.
 */
export const calculatePagination = createSelector(
  [filterSearches, limit, _page],
  (searches, limit, page) => {
    return {
      page,
      pages: Math.ceil(searches.length / limit),
      totalSearches: searches.length,
    }
  },
)
